'use client';

import { ReleaseNoteKind } from 'database';
import { useTranslations } from 'i11n';
import { Badge, BadgeProps, cn } from 'ui';

const kindVariants: Record<ReleaseNoteKind, BadgeProps['variant']> = {
  feature: 'warning',
  improvement: 'info',
  fix: 'neutral',
};

// `quiet` drops the kind's color, for the reader's pages where it is metadata.
export const ReleaseNoteKindBadge = ({
  kind,
  quiet = false,
  className,
}: {
  kind: ReleaseNoteKind;
  quiet?: boolean;
  className?: string;
}) => {
  const t = useTranslations();

  return (
    <Badge
      variant={quiet ? 'neutral' : kindVariants[kind]}
      className={cn('whitespace-nowrap font-medium', className)}
    >
      {t(`release-notes.kind.${kind}`)}
    </Badge>
  );
};
